import { FC } from 'react';
import './styles.scss';

const colors = ['#4285F4', '#34A853', '#FBBC05', '#EA4335'];

interface IProps {
  name: string;
}

const GoogleAvatar: FC<IProps> = ({ name }) => {
  return (
    <div
      className='google-avatar'
      style={{ background: colors[Math.floor(Math.random() * colors.length)] }}
    >
      {name.slice(0, 1)}
    </div>
  );
};
export default GoogleAvatar;
